export default __webpack_public_path__ + "static/media/compcom.78971c04.jpg";